import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
} from '@angular/core';
import { View } from '@wdx/clmi/clmi-swagger-gen';
import {
    FeatureFlag,
    TRANSLATION_CREATE_NEW,
    TRANSLATION_ENTITY_SAVEDFILTER_PLURAL,
    TRANSLATION_FILTER_PERSONAL_VIEW,
    TRANSLATION_FILTER_SYSTEM_VIEW,
    WdxDestroyClass,
} from '@wdx/shared/utils';
import { ICON_USER_COG } from '../../../../constants/icons.constants';
import { FormFiltersConfig, FormFiltersEvent } from '../form-filters.component';
import {
    FilterQueryService,
    FilterViewFacadeService,
} from '../shared/services';
import { QuerySectionsFacadeService } from './../shared/services/query-sections-facade/query-sections-facade.service';

@Component({
    selector: 'clmi-simple-view',
    templateUrl: './simple-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SimpleFilterViewComponent extends WdxDestroyClass {
    private filterViewFacadeService = inject(FilterViewFacadeService);
    private querySectionsFacadeService = inject(QuerySectionsFacadeService);
    private filterQueryService = inject(FilterQueryService);

    @Input() config: FormFiltersConfig = {};
    @Output() formFiltersEvent = new EventEmitter<FormFiltersEvent>();

    personalViews: View[] = [];
    readonly ICON_USER_COG = ICON_USER_COG.icon;
    readonly FEATURE_FLAG_CUSTOM_VIEWS = FeatureFlag.CustomViews;
    readonly CREATE_NEW = TRANSLATION_CREATE_NEW;
    readonly ENTITY_SAVEDFILTER_PLURAL = TRANSLATION_ENTITY_SAVEDFILTER_PLURAL;
    readonly FILTER_PERSONAL_VIEW = TRANSLATION_FILTER_PERSONAL_VIEW;
    readonly FILTER_SYSTEM_VIEW = TRANSLATION_FILTER_SYSTEM_VIEW;

    public viewsSystem$ = this.filterViewFacadeService?.viewsSystem$;
    public viewsPersonal$ = this.filterViewFacadeService?.viewsPersonal$;

    constructor() {
        super();
        this.filterQueryService.updateTableHeader$.next({ isFavourite: false });
    }

    toggleQueryBuilder(): void {
        this.querySectionsFacadeService.toggleQueryBuilder();
        this.filterQueryService.inBuilder = true;
    }
}
